import AddConnectorContainer from "./AddConnectorContainer";
import AddConnectorTypeStore from "./AddConnectorStore";

export default AddConnectorTypeStore(AddConnectorContainer); 
